import axios from "axios";

export type Prediction = {
  description: string;
  place_id: string;
};

async function locationAutocomplete(
  input: string,
  sessionToken: string
): Promise<Array<Prediction>> {
  const response = await axios.get<Array<Prediction>>(
    "/api/google_maps/autocomplete",
    {
      params: { input, session_token: sessionToken },
    }
  );

  return Promise.resolve(response.data);
}

export default locationAutocomplete;
